import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import WhyUs from "./pages/WhyUs";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminApplicants from "./pages/AdminApplicants";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/about" element={<><Header /><About /><Footer /></>} />
          <Route path="/services" element={<><Header /><Services /><Footer /></>} />
          <Route path="/industries" element={<><Header /><Industries /><Footer /></>} />
          <Route path="/why-us" element={<><Header /><WhyUs /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          
          {/* Admin Routes (No Header/Footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/applicants" element={<AdminApplicants />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
